// extracted by mini-css-extract-plugin
export default {"modalOverlay":"sA-z","modalContent":"tA-z","header":"uA-z","close":"vA-z"};